/** Loads the page again: the app's one way to reload, for a stuck start or a new release. */
export function reloadPage(): void {
  window.location.reload();
}
